import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { authReducer } from './app/store/reducers/auth.reducers';
import { AuthEffects } from './app/store/effects/auth.effects';
import { errorInterceptor, tokenInterceptor } from './app/services/token.interceptor';
import { predictionReducer } from './app/store/reducers/prediction.reducer';
import { PredictionEffects } from './app/store/effects/prediction.effects';
import { sportReducer } from './app/store/reducers/sport.reducer';
import { SportEffects } from './app/store/effects/sport.effects';
import { competitionsReducer } from './app/store/reducers/competitions.reducer';
import { CompetitionsEffects } from './app/store/effects/competitions.effects';
import { FollowPredictionEffects } from './app/store/effects/follow-prediction.effects';
import { followPredictionReducer } from './app/store/reducers/follow-prediction.reducer';
import { creditsReducer } from './app/store/reducers/credits.reducers';
import { CreditsEffects } from './app/store/effects/credits.effects';
import { PacksEffects } from './app/store/effects/packs.effects';
import { packsReducer } from './app/store/reducers/packs.reducers';
import { MessageService } from 'primeng/api';
import { SubscriptionPlansEffects } from './app/store/effects/subscription-plans.effects';
import { subscriptionPlansReducer } from './app/store/reducers/subscription-plans.reducers';
import { TeamsEffects } from './app/store/effects/teams.effects';
import { teamsReducer } from './app/store/reducers/teams.reducer';
import { projectsReducer } from './app/store/reducers/project.reducers';
import { ProjectsEffects } from './app/store/effects/projects.effects';
import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular'; 
export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(),
            withInterceptors([tokenInterceptor, errorInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },

        provideStore({ auth: authReducer , packs : packsReducer, prediction: predictionReducer, sport: sportReducer, competitions: competitionsReducer, teams : teamsReducer ,
             followedPrediction: followPredictionReducer, credits : creditsReducer, subscriptionPlans : subscriptionPlansReducer,
            projects: projectsReducer
            }),
        provideEffects(AuthEffects, PredictionEffects, SportEffects, CompetitionsEffects, FollowPredictionEffects, CreditsEffects, PacksEffects, SubscriptionPlansEffects, TeamsEffects, ProjectsEffects ),
        MessageService
    ]
};
